import type { CategorySummary } from '@/api/security'

/**
 * Cores do heatmap OWASP — resolvidas do Design System (docs/DESIGN_SYSTEM.md)
 * e do mockup aprovado (direção B):
 *  - crítico #e03131 (danger), alto #f76707, médio #f59f00 (warning)
 *  - baixo/info descem a rampa (amarelo claro / cinza) — raros, fora do mockup
 *  - "limpo" (avaliado, 0 aberto) = teal5 #098d93 (verde da marca)
 *  - "não avaliado" = superfície apagada + borda tracejada + cadeado (≠ limpo)
 */
export const SEVERITY_BG: Record<string, string> = {
  critical: '#e03131',
  high: '#f76707',
  medium: '#f59f00',
  low: '#fab005',
  info: '#868e96',
}

export const CLEAN_BG = '#098d93' // teal5 — avaliado e sem finding aberto
export const NA_BG = '#eef2f3'
export const NA_BORDER = '#c6d2d4'
export const NA_TEXT = '#5c636a'

export type CellState = 'critical' | 'high' | 'medium' | 'low' | 'info' | 'clean' | 'na'

/** Estado visual de uma célula: pior severidade aberta, "limpo" ou "não avaliado". */
export function cellState(cat: CategorySummary): CellState {
  if (!cat.evaluated) return 'na'
  if (cat.open_count > 0 && cat.worst_severity && cat.worst_severity in SEVERITY_BG) {
    return cat.worst_severity as CellState
  }
  // avaliado sem finding aberto (ou severidade desconhecida) = limpo
  return 'clean'
}

/** Cor de fundo da célula a partir do estado. */
export function cellBackground(state: CellState): string {
  if (state === 'na') return NA_BG
  if (state === 'clean') return CLEAN_BG
  return SEVERITY_BG[state] ?? CLEAN_BG
}
